// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panner[data-v-235e875f]{overflow-x:scroll;overflow-y:hidden;width:100%}.panner[data-v-235e875f]::-webkit-scrollbar{height:1px;width:1px}.panner[data-v-235e875f]::-webkit-scrollbar-thumb{background:#555}.panner[data-v-235e875f]>*{display:block;max-width:none;min-width:100%;width:-moz-max-content;width:max-content}.panner[data-v-235e875f]>table{display:inline-table}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
